import {Platform} from 'react-native';
import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';

export const useCertificateCardStyles = () => {
  return useStyles(({theme, mediaOnly}) => ({
    cardContainer: {
      shadowColor: theme.color.shaddowBg,
      shadowOpacity: 0.8,
      shadowRadius: 20,
      shadowOffset: {
        width: 0,
        height: 10,
      },
      overflow: 'hidden',
      borderColor: theme.color.borderColor,
      borderWidth: 2,
      borderRadius: 5,
      backgroundColor: theme.color.primaryNonGreyBackground,
      elevation: 5,
      display: Platform.OS === 'web' ? ('block' as 'none' | 'flex' | undefined) : 'flex',
      paddingBottom: 10,
    },
    cardContent: {
      ...mediaOnly(
        DeviceSize.desktop,
        {flexDirection: 'row', flexWrap: 'wrap', paddingHorizontal: 40, paddingVertical: 20},
        {alignItems: 'flex-start', paddingHorizontal: 30, paddingVertical: 8},
      ),
      gap: 15,
    },
    image: {
      position: 'absolute',
      top: 0,
      left: undefined,
      right: 0,
      bottom: 0,
      width: 495,
    },
    cardColumn: {
      ...mediaOnly(DeviceSize.desktop, {flexBasis: '18%'}),
    },
    cardColumn2: {
      ...mediaOnly(DeviceSize.desktop, {flexBasis: '18%'}),
      textAlign: 'right',
    },
    columnTitle: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          marginBottom: 5,
          ...theme.fonts.body,
          color: theme.color.labelText,
        },
        {
          marginBottom: 0,
          lineHeight: 30,
          fontWeight: 'bold',
          color: theme.color.textColor,
        },
      ),
      fontFamily: 'GothamPro',
      fontSize: 16,
    },
    columnText: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          fontSize: 20,
          fontWeight: 'bold',
          color: theme.color.textColor,
        },
        {
          // textAlign: 'center',
          fontSize: 16,
          fontWeight: '200',
        },
      ),
      fontFamily: 'GothamPro',
      lineHeight: 30,
      color: '#333333',
    },
    balance: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          fontSize: 40,
          fontWeight: '600',
        },
        {
          fontSize: 24,
          fontWeight: '500',
        },
      ),
      fontFamily: 'GothamPro',
      // textOverflow: 'ellipsis',
      // whiteSpace: 'nowrap',
      overflow: 'hidden',
      color: theme.color.primaryColor,
    },
  }));
};
